import memoize from "lodash-es/memoize";

import { loadScript } from "nvent-web/utils/script";

declare const Munchkin: munchkin.Global;

export function shouldLoad() {
  return Boolean(import.meta.env.VITE_MARKETO_ID);
}

export const load = memoize(async (): Promise<munchkin.Global> => {
  const id = import.meta.env.VITE_MARKETO_ID;

  if (!id) {
    throw new Error("Missing VITE_MARKETO_ID env value");
  }

  await loadScript("//munchkin.marketo.net/munchkin.js");
  Munchkin.init(id);

  return Munchkin;
});

export async function get(): Promise<munchkin.Global | undefined> {
  try {
    return await load();
  } catch {
    return undefined;
  }
}
